<div class="slice-container card flex justify-content-center">    
    <div class="phase-container card flex justify-content-center">
        <label for="slice">Phase</label>
        <p-selectButton 
        [options]="phaseOptions" 
        [(ngModel)]="phaseValue" 
        multiple="true"
        (onChange)="onScopePhaseChange($event, 'phase')"
        optionLabel="label" 
        optionValue="value" />
    </div>
</div>
<div class="chart-container card flex space-around">
    <p-chart #chart type="bar" [data]="chartResults" (onDataSelect)="filterByRange($event)" [options]="chartOptions" class="w-half md:w-[60rem]"></p-chart>
    <app-detail-table [data]="detailTableData"></app-detail-table>
</div>